export enum ViewType {
  EPISODE = 'EPISODE',
  FAVORITES = 'FAVORITES',
  MODULES = 'MODULES',
  MY_AUDIO = 'MY_AUDIO',
  SEARCH = 'SEARCH',
  SET_LOCATION = 'SET_LOCATION',
  SHOW = 'SHOW',
  STATION = 'STATION',
  TAG = 'TAG',
  PLAYLIST = 'PLAYLIST',
  AUTO_HOME = 'AUTO_HOME',
}

export enum EntityType {
  ARTICLE = 'ARTICLE',
  CLIP = 'CLIP',
  COLLECTION = 'COLLECTION',
  EPISODE = 'EPISODE',
  GEOGRAPHY = 'GEOGRAPHY',
  ORGANIZATION = 'ORGANIZATION',
  PERSON = 'PERSON',
  STATION = 'STATION',
  SHOW = 'SHOW',
  TAG = 'TAG',
  STANDALONE_CHAPTER = 'CHAPTER',
  TOPIC = 'TOPIC',
}

export enum Category {
  MUSIC = 'music',
  NEWS_TALK = 'news-talk',
  SPORTS = 'sports',
  Playlist = 'playlist',
}

export enum NotificationType {
  Email = 'AUDACY_EMAIL',
  Push = 'AUDACY_PUSH',
}

export enum GenderType {
  Male = 'MALE',
  Female = 'FEMALE',
  NonBinary = 'NON_BINARY',
  PreferNotToSay = 'PREFER_NOT_TO_SAY',
}

export enum UserType {
  Consumer = 'CONSUMER',
}

export enum ContentType {
  Full = 'FULL',
  Summary = 'SUMMARY',
}

export enum AuthType {
  Authenticated = 'AUTHENTICATED',
  Unauthenticated = 'UNAUTHENTICATED',
}

export enum SortType {
  DateAscending = 'DATE_ASC',
  DateDescending = 'DATE_DESC',
}

export enum AdTargetingGroup {
  AdTargeting = 'adTargeting',
}

export enum AudacyPlatform {
  Web = 'WEB',
  Mobile = 'MOBILE',
}

export enum AudacyPlatformVariant {
  Ios = 'IOS',
  Android = 'ANDROID',
  None = 'NONE',
}

export type EntitySubtype =
  | ArticleSubtype
  | AudioClipSubtype
  | CollectionSubType
  | EpisodeSubType
  | OrganizationSubtype
  | ShowSubtype
  | PersonSubtype
  | StationSubType
  | TagSubtype
  | StandaloneChapterSubType;

export enum ArticleSubtype {
  ARTICLE = 'ARTICLE',
}

export enum AudioClipSubtype {
  ADVERT = 'ADVERT',
  CLIP = 'CLIP',
  SEGMENT = 'SEGMENT',
  SONG = 'SONG',
  SOUNDER = 'SOUNDER',
}

export enum CollectionSubType {
  PLAYLIST = 'PLAYLIST',
}

export enum EpisodeSubType {
  BROADCAST_SHOW_EPISODE = 'BROADCAST_SHOW_EPISODE',
  PODCAST_EPISODE = 'PODCAST_EPISODE',
  HOST_CREATED_EPISODE = 'HOST_CREATED_EPISODE',
}

export enum StandaloneChapterSubType {
  BROADCAST_EPISODE_CHAPTER = 'BROADCAST_EPISODE_CHAPTER',
}

export enum OrganizationSubtype {
  ORGANIZATION = 'ORGANIZATION',
}

export enum PersonSubtype {
  PERSON = 'PERSON',
}

export enum ShowSubtype {
  DIGITAL = 'DIGITAL_SHOW',
  BROADCAST = 'BROADCAST_SHOW',
  HOST_CREATED = 'HOST_CREATED',
  PODCAST = 'PODCAST',
  PLAYLIST = 'PLAYLIST',
}

export enum TagSubtype {
  TEAM = 'Team',
  LEAGUE = 'League',
  GENRE = 'Genre',
}

export enum StationSubType {
  BROADCAST = 'BROADCAST_RADIO',
  INTERNET = 'INTERNET_RADIO',
  EXCLUSIVE = 'EXCLUSIVE_STATION',
  TOPIC = 'TOPIC_BASED',
  PERSONALIZED = 'PERSONALIZED_RADIO',
  PODCAST = 'PODCAST_EPISODE',
}

export enum ApiVersion {
  V1 = 'v1',
  V2 = 'v2',
  V3 = 'v3',
}

export enum SocialMediaPlatform {
  FACEBOOK = 'facebook',
  TWITTER = 'twitter',
  INSTAGRAM = 'instagram',
  YOUTUBE = 'youtube',
}
